import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { catchError, map, switchMap } from 'rxjs/operators';
import { EMPTY, from, of } from 'rxjs';

import { TelespotPipelineService } from '../../services';
import { stepActions } from './step.actions';
import { labelActions, labelSelectors } from '../protocol-labels';
import { stepSelectors } from '../..';

@Injectable()
export class TelespotStepEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly service: TelespotPipelineService
  ) {}

  findForSample = createEffect(() =>
    this.actions$.pipe(
      ofType(stepActions.findForSample),
      switchMap(({ sampleId }) =>
        from(this.service.findStepsForSample(sampleId)).pipe(
          map((results) => stepActions.findForSampleSuccess(results)),
          catchError((error) => of(stepActions.findForSampleFailure({ error: error.message })))
        )
      )
    )
  );

  findForSampleSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(stepActions.findForSampleSuccess),
      concatLatestFrom(() => [
        this.store.select(labelSelectors.selectIds),
        this.store.select(stepSelectors.selectCategories),
      ]),
      switchMap(([{ steps }, labelIds, categories]) => {
        const uuids: string[] = [];

        for (const step of steps) {
          for (const category of step.categories) {
            uuids.push(category);
            uuids.push(...(categories[category]?.options ?? []));
          }
        }

        const missingLabelIds = uuids.filter((labelId) => !labelIds.map(String).includes(labelId));

        if (!missingLabelIds.length) return EMPTY;

        return of(labelActions.fetchLabelsByUUID({ uuids: missingLabelIds }));
      })
    )
  );
}
